import css from "./style.this.css";
import { h } from "preact";
import { style } from "cssthis";

export default style("button")(css);
